import { render, staticRenderFns } from "./LibraryLayout.vue?vue&type=template&id=a25c5824&"
import script from "./LibraryLayout.vue?vue&type=script&lang=js&"
export * from "./LibraryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a25c5824')) {
      api.createRecord('a25c5824', component.options)
    } else {
      api.reload('a25c5824', component.options)
    }
    module.hot.accept("./LibraryLayout.vue?vue&type=template&id=a25c5824&", function () {
      api.rerender('a25c5824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/LibraryLayout.vue"
export default component.exports